import { getUserAccountType } from './getUserAccountType';
import { ClientUserAccessType } from '../../enums/ClientUserAccessType';

export const isUserAccountUser = (userData): boolean => {
    return getUserAccountType(userData) === ClientUserAccessType.clientUser;
};
